// ═══════════════════════════════════════════════════════════════
// API CLIENT: Vacaciones
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const vacacionesAPI = {
  // Obtener todas las solicitudes
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.estado) params.append('estado', filters.estado);
    if (filters.employee_id) params.append('employee_id', filters.employee_id);
    if (filters.anio) params.append('anio', filters.anio);

    const response = await api.get(`/vacaciones${params.toString() ? `?${params}` : ''}`);
    return response.data;
  },

  // Obtener solicitud por ID
  getById: async (id) => {
    const response = await api.get(`/vacaciones/${id}`);
    return response.data;
  },

  // Crear nueva solicitud
  create: async (data) => {
    const response = await api.post('/vacaciones', data);
    return response.data;
  },

  // Actualizar solicitud
  update: async (id, data) => {
    const response = await api.put(`/vacaciones/${id}`, data);
    return response.data;
  },

  // Aprobar solicitud
  aprobar: async (id) => {
    const response = await api.post(`/vacaciones/${id}/aprobar`);
    return response.data;
  },

  // Rechazar solicitud
  rechazar: async (id, comentarios_rechazo) => {
    const response = await api.post(`/vacaciones/${id}/rechazar`, { comentarios_rechazo });
    return response.data;
  },

  // Eliminar/Cancelar solicitud
  delete: async (id) => {
    const response = await api.delete(`/vacaciones/${id}`);
    return response.data;
  },

  // Obtener balance de días para un empleado
  getBalance: async (employee_id, anio) => {
    const params = anio ? `?anio=${anio}` : '';
    const response = await api.get(`/vacaciones/balance/${employee_id}${params}`);
    return response.data;
  },

  // Obtener calendario mensual
  getCalendario: async (anio, mes) => {
    const response = await api.get(`/vacaciones/calendario/${anio}/${mes}`);
    return response.data;
  },

  // Obtener estadísticas
  getStats: async (anio) => {
    const params = anio ? `?anio=${anio}` : '';
    const response = await api.get(`/vacaciones/stats/summary${params}`);
    return response.data;
  }
};

export default vacacionesAPI;
